import React, { useEffect, useState } from 'react';
import { CImg, CLink } from '@coreui/react';
import { useFormContext } from 'react-hook-form';

interface IFileUpload {
  name?: string;
  contentType?: string;
  fileSrc?: string;
  acceptType?: string[];
  maxSize?: number;
  innerRef?: object | Function;
  onFieldChange: Function;
}

export const FileUpload: React.FC<IFileUpload> = ({
  name='file',
  contentType = '',
  fileSrc = '',
  acceptType = ['.jpeg', '.png', '.jpg'],
  maxSize,
  innerRef,
  onFieldChange,
}) => {
  const imgReg = /png|jpeg|jpg/;
  const [imageBas64, setImageBas64] = useState('');
  const [file, setFile] = useState({} as File);
  const [image, setImage] = useState('');
  const [isImage, setIsImage] = useState(false);
  const { register, setError, errors, clearErrors, setValue } = useFormContext();

  const onChange = (e: any) => {
    const files = e.target.files;
    const contentType = files[0].type;
    const isImage = /png|jpeg|jpg/.test(contentType);
    setValue(name, files);
    clearErrors(name);
    setFile(files[0]);
    if (acceptType.length && isImage) {
     createBase64Image(files[0]);
    }
    onFieldChange(e);
  };

  useEffect(() => {
    if (contentType && !file?.name) {
      setIsImage(imgReg.test(contentType));
    } else {
      setIsImage(imgReg.test(file.type));
    }
  }, [contentType, setIsImage, file, imgReg]);

  useEffect(() => {
    if ((fileSrc || imageBas64) && isImage) {
      setImage((imageBas64 || fileSrc));
    } else {
      setImage('');
    }
  }, [fileSrc, imageBas64, isImage, setImage]);

  useEffect(() => {
    if (maxSize && file.size > maxSize) {
      setError(name, {
        message: `Selected file size exceed ${getFileSize(maxSize)}`
      });
      setImageBas64('');
    }
  }, [file, setError, maxSize, name]);

  const getFileSize = (size: number) => {
    if (size < 1024) {
      return size + 'bytes';
    } else if (size >= 1024 && size < 1048576) {
      return (size/1024).toFixed(1) + 'KB';
    } else if (size >= 1048576) {
      return (size/1048576).toFixed(1) + 'MB';
    }
  };

  const createBase64Image = (file: File) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.addEventListener("load", function () {
      setImageBas64(reader.result as string);
    }, false);
  };

  return (
    <>
      <div className="file-upload-container">
        {!isImage && fileSrc && !errors?.[name] &&
          <CLink href={!file?.name ? fileSrc : URL.createObjectURL(file)} target="_blank">View</CLink>
        }
        {!isImage && !fileSrc && file?.name && !errors?.[name] &&
          <CLink href={URL.createObjectURL(file)} target="_blank">View</CLink>
        }
        &nbsp; &nbsp;
        <label htmlFor={name} className="btn variant-primary">
          {(fileSrc || image || file?.name) ? "Choose" : "Browse"}
        </label>
        &nbsp; &nbsp;
        {file &&
          <span>{file.name}</span>
        }
        <input
          type="file"
          name={name}
          className="d-none"
          id={name}
          ref={innerRef as any}
          accept={acceptType.toString()}
          onChange={(e) => onChange(e)}/>
      </div>
      {image && !errors?.[name] &&
        <>
          <CImg
            src={image}
            thumbnail={true}
            width="50%"
            className="image-tmb"
          />
        </>
      }
    </>
  );
};
